export const environment = {
  production: true,
  domain: 'https://choiga188.com',
  endPointWS: 'https://api.choiga188.com',
  endPointApi: 'https://api.choiga188.com/api',
  domainDownload : 'https://tai.choiga188.com',
  VERSION_ANDROID: '1.0',
  VERSION_IOS: '1.0',
  CODE: '',
  tawk: '',

};
